export const filterElements = <T extends Record<keyof T, unknown>>(
  search: string,
  elements: T[],
  key: keyof T
): T[] => {
  const condition = createPattern(search);

  return elements.filter((element) => condition.test(element[key]));
};

export const filterElementsByManyKeys = <T extends Record<keyof T, unknown>>(
  search: string,
  elements: T[],
  keys: (keyof T)[]
): T[] => {
  const condition = createPattern(search);
  return elements.filter((element) => !!keys.find((key) => condition.test(element[key])));
};

export const conditionForFilterElementsByManyKeys = <T extends Record<keyof T, unknown>>(
  search: string,
  element: T,
  keys: (keyof T)[]
): boolean => {
  const condition = createPattern(search);
  return !!keys.find((key) => condition.test(element[key]));
};

function createPattern(search: string) {
  const normalizedSearch = normalizeString(search);

  return {
    test: (value: unknown) => {
      const typeGuard = typeof value === 'string';
      if (typeGuard) {
        return normalizeString(value).includes(normalizedSearch);
      }
      return true;
    }
  };
}

function normalizeString(value: string) {
  return value.toLocaleLowerCase();
}
